// extracted by mini-css-extract-plugin
export default {"catalog":"Catalog_catalog__7FhN1","categoriesH":"Catalog_categoriesH__akhf8","cardCategories":"Catalog_cardCategories__WmVxH"};